import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
var ConversationSearch = function (props) {
    var t = useTranslation(["chat"]).t;
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "search-bar", children: [_jsx("input", { onChange: function (e) { return props.handleSearchQuery(e.target.value); }, type: "text", value: props.searchQuery, 
                    /* @ts-ignore */
                    placeholder: t("Search") }), _jsx("button", { type: "button", children: _jsx("img", { src: "".concat(process.env.IMG_URL, "/static/vendors/images/icons/recherche.svg"), alt: "search" }) })] }) }));
};
export default ConversationSearch;
